import Checkbox from './Checkbox';

/**
 * @param {string} props.category.id
 * @param {string} props.category.title
 * @param {boolean} props.category.isActive
 * @param {object} props.onClick
 */
const CheckList = (props) => {
  let itemKeys = props.list;

  return (
    <>
      {
        itemKeys.map(key => {
          if(key.length >= 5) return;
          let item = props.category[key];
          let checkboxProps = {
            label : item.title,
            id: item.id,
            isActive: item.isActive,
          }
          return (
            <Checkbox {...checkboxProps} onClick={props.onClick}/>
          )
        })
      }
    </>
  )
}


export default CheckList;